import axios from 'axios';
import { AuthService } from './authService';

let refreshRequest: any = null;

const sendRefreshRequest = async () => {
    try {
        await AuthService.refreshAccessToken();
        refreshRequest = null;
    } catch (e) {
        await AuthService.redirectToSignIn();
    }
};

export const createAxios = (baseURL: string) => {
    const axiosInstance = axios.create({ baseURL });

    /**
     * On request add the bearer token from the Session storage
     */
    axiosInstance.interceptors.request.use(
        async (config) => {
            const token = await AuthService?.getAccessToken();
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
                axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            }

            return config;
        },
        (error) => {
            return Promise.reject(error.response);
        }
    );

    /**
     * On an error response refresh the access token and
     * use the new access token from Session storage
     */
    axiosInstance.interceptors.response.use(
        (response) => {
            return response;
        },
        async (error) => {
            const originalRequest = error.config;
            /** If access token is invalid, get another token with the refresh token */
            if (
                (error.response?.status === 403 && !originalRequest?._retry) ||
                (error.response?.status === 401 && !originalRequest?._retry)
            ) {
                originalRequest._retry = true;
                try {
                    if (!refreshRequest) {
                        refreshRequest = sendRefreshRequest();
                    }

                    await refreshRequest;
                    const token = await AuthService?.getAccessToken();
                    if (token) {
                        originalRequest.headers.Authorization = `Bearer ${token}`;
                        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
                    }
                } catch (e) {
                    return Promise.reject(e);
                }
                return axiosInstance(originalRequest);
            }

            if (error.code === 'ERR_NETWORK') {
                return Promise.reject(error);
            }
            return Promise.reject(error?.response?.data ?? error?.response);
        }
    );

    return axiosInstance;
};
